import _ from 'lodash';

function computeData(scoreTypes, childWalkables, learners) {
  const totalScore = _.sumBy(childWalkables, (childWalkable) => {
    let totalScoreOfAWalkable;
    if (childWalkable.totalScore === null || childWalkable.totalScore === undefined) {
      totalScoreOfAWalkable = 0;
    } else {
      totalScoreOfAWalkable = Number(childWalkable.totalScore);
      if (!isFinite(totalScoreOfAWalkable) || totalScoreOfAWalkable < 0) {
        totalScoreOfAWalkable = 0;
      }
    }
    return totalScoreOfAWalkable;
  });

  const learnersWithPercentages = _.chain(learners)
    .map((learner) => {
      const { scores, ...otherFields } = learner;

      const totalAchievedScore = _.sumBy(scores, (scoreObj) => {
        if (scoreObj.scoreType === scoreTypes.GRADED || scoreObj.scoreType === scoreTypes.PARTIALLY_GRADED) {
          return scoreObj.score;
        }
        return 0;
      });

      const nonRoundedPercentage = (totalAchievedScore / totalScore) * 100;
      const percentage = Math.round(nonRoundedPercentage);

      return { scores, ...otherFields, percentage, nonRoundedPercentage };
    })
    .value();

  const totalPercentage = Math.round(_.meanBy(learnersWithPercentages, 'nonRoundedPercentage'));

  const childWalkablesWithScoreSummaries = childWalkables.map((childWalkable) => {
    const childWalkableScores = learners.reduce((scores, learner) => {
      const { scores: learnerScores } = learner;
      const resultScoreObj = _.find(learnerScores, (scoreObj) => (
        scoreObj.walkableId === childWalkable.id &&
        (scoreObj.scoreType === scoreTypes.GRADED || scoreObj.scoreType === scoreTypes.PARTIALLY_GRADED)
      ));
      if (typeof resultScoreObj !== 'undefined') {
        scores.push(resultScoreObj.score);
      }
      return scores;
    }, []);

    let lowest = _.min(childWalkableScores);
    let mean = _.mean(childWalkableScores);
    const sortedScores = _.sortBy(childWalkableScores, (num) => num);
    const middleValues = sortedScores.length % 2 === 0 ?
      [sortedScores[(sortedScores.length / 2) - 1], sortedScores[sortedScores.length / 2]] :
      [sortedScores[(sortedScores.length - 1) / 2]];
    let median = _.mean(middleValues);
    let highest = _.max(childWalkableScores);

    lowest = _.round(lowest, 2);
    mean = _.round(mean, 2);
    median = _.round(median, 2);
    highest = _.round(highest, 2);

    return { ...childWalkable, lowest, mean, median, highest };
  });

  const gradesSummaryShouldBeShown = _.chain(childWalkables)
    .map((childWalkable) => {
      const { id } = childWalkable;

      if (learners.length === 0) {
        return { id, value: false };
      }
      if (childWalkable.totalScore === null || childWalkable.totalScore === undefined) {
        return { id, value: false };
      }
      const totalScoreOfAWalkable = Number(childWalkable.totalScore);
      if (!isFinite(totalScoreOfAWalkable) || totalScoreOfAWalkable < 0) {
        return { id, value: false };
      }
      return { id, value: true };
    })
    .keyBy('id')
    .value();

  return {
    learnersWithPercentages,
    totalPercentage,
    childWalkablesWithScoreSummaries,
    gradesSummaryShouldBeShown,
  };
}

export { computeData };
